(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-diluxe-copy-code]');
    if (!button || button.disabled) return;
    const status = button.closest('.diluxe-deal-notice').querySelector('[role="status"]');
    const originalLabel = button.textContent;
    button.disabled = true;
    status.textContent = '';
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(button.dataset.diluxeCopyCode);
      button.textContent = button.dataset.copySuccess;
      status.textContent = button.dataset.copySuccess;
      setTimeout(() => { button.textContent = originalLabel; }, 2500);
    } catch {
      status.textContent = button.dataset.copyFailure;
    } finally {
      button.disabled = false;
    }
  });
})();
